import * as types from './types';
import { loading } from 'State/actions';
import { fetchGeneric } from 'State/generic/actions';

export const getRevenueSummaryReport = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(loading(types.REVENUE_SUMMARY_REPORT_FETCHING, true));

    try {
      const response = await MPWWebAPI.postGenericInsertUpdate(
        'Reports/RevenueSummaryReport',
        data
      );
      dispatch({
        type: types.REVENUE_SUMMARY_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.REVENUE_SUMMARY_REPORT_FETCH_ERROR,
        errors: error.response.Errors,
      });
    }

    dispatch(loading(types.REVENUE_SUMMARY_REPORT_FETCHING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.REVENUE_SUMMARY_REPORT_GET_REPORT,
    payload: null,
  };
};

export const getReimbursementRates = () => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.REVENUE_SUMMARY_REPORT_GET_REIMBURSEMENT_RATES,
        types.REVENUE_SUMMARY_REPORT_FETCHING,
        types.REVENUE_SUMMARY_REPORT_FETCH_ERROR,
        `ReimbursementRate`
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/pages/revenuesummaryreport/state/report/actions.js